<script>
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import Body from "./Body.svelte";
  import Footer from "./Footer.svelte";
  import Header from "./Header.svelte";
  import { assignLicenseModalProps } from "./stores";

  let clientHeight = $state(0);
  let style = $derived(`height:calc(100% - ${clientHeight}px)`);

  const onclose = () => {
    $assignLicenseModalProps = {
      show: false,
      userId: null,
      originalLicenses: [],
    };
  };
</script>

{#if $assignLicenseModalProps.show}
  <Modal size="medium" {onclose} closeButton={false}>
    <Header slot="header" />
    <Body {style} />
    <Footer bind:clientHeight {onclose} />
  </Modal>
{/if}
